<div class="container-fluid movieInfo pl-0 pr-0 ">
  <div class="row  mx-0  movieinfoBackground" [ngStyle]="{'background' : 'url('+ seriesinfo?.info.cover +') no-repeat '}">
    <!-- mx-xl-5  m-lg-1-->
    <!-- <div class="cursor-pointer fs-16 m-2" style="z-index: 20;">
      <a style="color: white" (click)="back(categoryId)">
        <i class="fas fa-arrow-alt-left"></i> {{ 'COMMON.BACK' | translate }}
      </a>
    </div> -->

    <div class="text-center col-12 m-auto" *ngIf="isLoading">
      <div class="spinner-border" role="status">
        <span class="sr-only">{{ 'COMMON.LOADING' | translate }}</span>
      </div>
    </div>

    <div class="col-md-12 mt-3 pl-5 mobile" *ngIf="seriesinfo">
      <div class="row mt-0 mt-lg-5">
        <!-- <div class="col-xl-4   img-contain mx-auto">
          <img [src]="seriesinfo.info.backdrop_path" class="info-img" alt="No image" loading=lazy>
          <div class="fav-icon icon-color" *ngIf="isFavourit"> <i class="fas fa-heart"></i></div>
        </div> -->

        <div class="col-md-7">
          <div class="row">
            <div class="col-12 text-left">

              <div class="bd-highlight infotitle">{{seriesinfo.info.name}}</div>
              <div class="d-none d-lg-block mt-3">
                <div class="d-flex flex-row bd-highlight mb-2">
                  <div class="bd-highlight category">{{seriesinfo.info.releaseDate |date:'YYYY'}} <span
                      class="mx-2 text-purple"></span>
                  </div>
                  <!-- <div class="bd-highlight category">{{seriesinfo.info.genre | slice:0:15}} 
                  </div> -->
                  <!-- <span class="mx-2 fs-22 text-purple">|</span> -->
                  <div class="bd-highlight season-len">
                    <div class="season-text">
                      {{ 'SERIES.SEASONS' | translate }} {{seasonLen}} 
                    </div>

                  </div>
                  <span class="mx-2 fs-22 text-purple"></span>
                  <div class="bd-highlight season-len">
                  <div class="season-text">
                  {{ 'SERIES.EPISODES' | translate }} {{episodeLen}}
                  </div>
                  </div>
                    <span class="mx-2 fs-22 text-purple"></span>
                    <div class="mb-lg-5 mb-3 fs-20">
                      <i class="fa fa-star text-warning"></i>
                      {{seriesinfo?.info?.rating}}
                      <!-- <i
                        class="fa fa-star mx-1"
                        [ngClass]="{
                          'text-purple': movieinfo.info.rating / 2 >= i + 1
                        }"
                        aria-hidden="true"
                        *ngFor="let item of [1, 2, 3, 4, 5]; let i = index"
                      ></i> -->
                    </div>
                  <!-- <div type="" class=" mr-lg-4 d-flex fav-center" *ngIf="!isFavourit" (click)="onSave(seriesinfo)"><i
                  class="fa fa-heart  px-3 px-lg-2 py-1"></i>{{ 'COMMON.ADD_TO_FAVOURITE' | translate }}</div>
                  <div type="" class=" mr-lg-4 d-flex fav-center" *ngIf="isFavourit" (click)="deleteFavourite(seriesinfo)"><i
                    class="fa fa-trash  px-3 px-lg-2 py-1"></i>{{ 'COMMON.REMOVE_FROM_FAVOURITE' | translate }}</div> 
                  <div class="d-flex"> -->
                    <span class="mx-2 fs-22 text-purple"></span>

                  <div type="" class=" mr-lg-4ng-star-inserted mb-0 fs-19 fw-700 fav-center" (click)="onSave(seriesinfo)" *ngIf="!isFavourit">
                    <!-- <span class="mx-2 fs-22 text-purple">|</span> -->
                    <i
                    class="far fa-heart   px-lg-2 py-lg-1 fs-22 "></i></div>
                   <div type="" class=" mr-lg-4 ng-star-inserted  mb-0 fs-19 fw-700 fav-center" (click)="deleteFavourite(seriesinfo)" *ngIf="isFavourit">
                  <!-- <span class="mx-2 fs-22 text-purple">|</span> -->
                  <i class="fas fa-heart px-lg-2 py-lg-1 fs-22"></i></div>
                </div>
              </div>
              <div class="d-lg-none d-block">
                <div class="fs-14">{{seriesinfo.info.releaseDate | date:'YYYY'}}</div>
                <div class="fs-14">{{seriesinfo.info.genre}}</div>
                <div class="fs-14">{{seasonLen}} {{ 'SERIES.SEASON' | translate }},{{episodeLen}}
                   {{ 'SERIES.EPISODE' | translate }}</div>
                  <div type="" class=" mr-lg-4ng-star-inserted mb-0 fs-19 fw-700 fav-center" (click)="onSave(seriesinfo)" *ngIf="!isFavourit">
                    <!-- <span class="mx-2 fs-22 text-purple">|</span> -->
                    <i
                    class="far fa-heart   px-lg-2 py-lg-1 fs-22 "></i></div>
                   <div type="" class=" mr-lg-4 ng-star-inserted  mb-0 fs-19 fw-700 fav-center" (click)="deleteFavourite(seriesinfo)" *ngIf="isFavourit">
                  <!-- <span class="mx-2 fs-22 text-purple">|</span> -->
                  <i class="fas fa-heart px-lg-2 py-lg-1 fs-22"></i></div>
              </div>
              <!-- <div class="mb-3">
                <i class="fa fa-star mx-1" [ngClass]="{'text-purple':(seriesinfo.info.rating/2)>=i+1 }"
                  aria-hidden="true" *ngFor="let item of [1,2,3,4,5];let i=index;"></i>
              </div> -->
              <div class="bd-highlight category">{{seriesinfo.info.genre}}</div> 
              <div>
                <p class="text-white  content-text series-desc">{{seriesinfo.info.plot}}</p>
              </div>


              <div class="d-flex-row flex-md-column bd-highlight mt-lg-5 mt-2 mb-2 ml-0">
                <button type="button" class="btn button-info mr-lg-4 mr-2 mb-2"
                  *ngIf="seriesinfo.info.youtube_trailer && seriesinfo.info.youtube_trailer.length > 0;"
                  [routerLink]="['/series/episodes/'+seriesinfo.info.youtube_trailer]">
                  <!-- <i class="fa fa-play  px-lg-4 py-lg-1 px-2 res1024"></i> -->
                <img src="./assets/images/new_icons/movie_series_play.svg" class="px-lg-2 py-lg-1 py-1 px-2 res1024" alt="">
                  {{ 'COMMON.TRAILER' | translate }}
                </button>
                <button type="button" class="btn button-info mr-lg-4 mr-2 mb-2" [routerLink]="['/series/list/'+this.id]"
                  [queryParams]="{seriesBy: this.seriesFrom}" *ngIf="seasonLen"><i
                    class="fa fa-film  px-lg-2 py-lg-1 py-1 px-2 res1024"></i>{{ 'SERIES.SEASONS' | translate }}</button>
                <button type="button" class="btn button-info mr-lg-4 mr-2 mb-2" *ngIf="episodeLen"
                  [routerLink]="['/series/episodelist/'+this.id]" [queryParams]="{seriesBy: this.seriesFrom}"><i
                    class="fa fa-video   px-lg-2 py-lg-1 py-1 px-2 res1024"></i>{{ 'SERIES.EPISODES' | translate }}</button>
                <!-- <button type="button" class="btn button-info mb-2 " (click)="onSave(seriesinfo)" *ngIf="!isFavourit"><i
                    class="fa fa-heart   px-lg-4 py-lg-1 py-1 px-2"></i>{{ 'COMMON.ADD_TO_FAVOURITE' | translate }}</button>
                <button type="button" class="btn button-info mb-2 " (click)="deleteFavourite(seriesinfo)" *ngIf="isFavourit"><i class="fa fa-trash   px-lg-4 py-lg-1 py-1 px-2"></i>{{ 'COMMON.REMOVE_FROM_FAVOURITE' | translate }}</button> -->
              </div>
            </div>
            <!-- <div class="col-12 text-left pt-2 pb-4 custom-slider">
              <h4>{{ 'SERIES.SEASONS' | translate }}</h4>

              <ngx-slick-carousel class="carousel custom-slider" #slickModal="slick-carousel" [config]="slideConfig">
                <div ngxSlickItem *ngFor="let item of seriesinfo.seasons;let i=index;" class="slide"
                  (click)="onSelectSeason(item.season_number)">
                  <div class="pr-md-3 pr-4">
                    <a class="cursor-pointer" *ngIf="seriesinfo.episodes">
                      <img class="search-img " [src]="item.cover" loading=lazy
                        [ngClass]="{'border-all':item.season_number==seasonId}" alt="First slide"></a>
                    <a class="cursor-pointer" *ngIf="!seriesinfo.episodes">
                      <img class="search-img " [src]="item.cover" loading=lazy
                        [ngClass]="{'border-all':item.season_number==seasonId}" alt="First slide"
                        [routerLink]="['/series/list/'+this.id]"></a>
                    <p class="episode-title">{{item.name}}</p>
                  </div>
                </div>
              </ngx-slick-carousel>
            </div> -->
            <!-- <div class="col-12 text-left pt-2 pb-4" *ngIf="seriesinfo.episodes && !isLoading">
              <h4>{{ 'SERIES.EPISODES' | translate }}</h4>
              <p *ngIf="!seriesinfo.selectedEpisodes || 
              (seriesinfo.selectedEpisodes && seriesinfo.selectedEpisodes.length == 0)">No Data available</p>
              <ngx-slick-carousel class="carousel custom-slider" #slickModal="slick-carousel" [config]="slideConfig"> -->
                <!--commmented becfore 11-05-23 <div ngxSlickItem *ngFor="let item of seriesinfo.episodes[seasonId];let i=index;" -->
                <!-- <div ngxSlickItem *ngFor="let item of seriesinfo.selectedEpisodes;let i=index;"
                  class="slide cursor-pointer" [routerLink]="['/series/watch/'+item.id+'/'+item.container_extension]">
                  <div class="pr-3">
                    <div class="pr-3">
                      <img class="search-imgseries" [src]="item.info.movie_image" alt="First slide" loading=lazy>
                      <p class="fs-14 search-title " title="{{ item.title }}">{{item.title |slice:0:20}}</p>
                    </div>
                  </div>
                </div>
              </ngx-slick-carousel>
            </div> -->
          </div>
        </div>
        <div class="col-md-5 img-contain mx-auto">
          <!-- <div class="image-overlay">
            <img [src]="seriesinfo.info.cover" class="info-img" alt="No image" loading=lazy>
          </div> -->
          <!-- <div class="fav-icon icon-color" *ngIf="isFavourit"> <i class="fas fa-heart"></i></div> -->
        </div>
        <!-- <div style="max-width: 95%;overflow-x: scroll;" class="col-12 text-center cursor-pointer season-scroll-btn d-flex pt-4">
            <div class="scroll-wrapper">
               <button (click)="scrollLeft()" [disabled]="isAtStart" class="scroll-btn">‹</button>
                <div class="season-name"  *ngFor="let item of seriesinfo.seasons;let i=index;" class="d-flex" >
                  <h4 class="episode-title d-flex  mr-5" (click)="onSelectSeason(item.season_number)" [ngClass]="{'border-all':item.season_number==seasonId}">{{item.name}}</h4>
                </div>
                <button (click)="scrollRight()" [disabled]="isAtEnd" class="scroll-btn">›</button>
            </div>
        </div> -->
  <div class="col-12 season-scroll-wrapper mt-4 cursor-pointer" [ngStyle]="{ 'margin-left': isScrollable ? '0.5rem' : '0rem' }">

  <!-- LEFT BUTTON (only shown if scrollable) -->
  <button *ngIf="isScrollable" (click)="scrollLeft()" [disabled]="isAtStart" class="scroll-btn left">
    <i class="fas fa-arrow-left fs-24"></i>
  </button>

  <!-- SCROLL CONTAINER -->
  <div class="scroll-container" #scrollContainer >
    <div class="season-name mt-2" [ngStyle]="{ 'margin-left': isScrollable ? '3rem' : '0rem' }" #seriesItem *ngFor="let item of seriesinfo.seasons; let i = index">
      <h4 class="episode-title mr-5" 
          (click)="onSelectSeason(item.season_number)" 
          [ngClass]="{'border-all': item.season_number == seasonId}">
        {{ item.name }}
      </h4>
    </div>
  </div>

  <!-- RIGHT BUTTON (only shown if scrollable) -->
  <button *ngIf="isScrollable" (click)="scrollRight()" [disabled]="isAtEnd" class="scroll-btn right">
    <i class="fas fa-arrow-right fs-24"></i>
  </button>

</div>


    
          
          <!-- <ngx-slick-carousel class="carousel custom-slider" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let item of seriesinfo.seasons;let i=index;" class="slide series-slide"
              (click)="onSelectSeason(item.season_number)" style="width: 220px !important;">
              <div class="pr-md-3 pr-4">
                <a class="cursor-pointer" *ngIf="seriesinfo.episodes">
                  <img class="slide-img" [src]="item.cover" loading=lazy
                    [ngClass]="{'border-all':item.season_number==seasonId}" alt="First slide">
                  </a>
                <a class="cursor-pointer" *ngIf="!seriesinfo.episodes">
                  <img class="search-img "  loading=lazy
                    [ngClass]="{'border-all':item.season_number==seasonId}" alt="First slide"
                    [routerLink]="['/series/list/'+this.id]"></a>
                <p class="episode-title">{{item.name}}</p>
              </div>
            </div>
          </ngx-slick-carousel> -->
        <div class="col-12 text-left mt-4 pb-4" *ngIf="seriesinfo.episodes && !isLoading">
          <!-- <h4>{{ 'SERIES.EPISODES' | translate }}</h4> -->
          <p *ngIf="!seriesinfo.selectedEpisodes || 
          (seriesinfo.selectedEpisodes && seriesinfo.selectedEpisodes.length == 0)">{{'COMMON.DATA_NOT_FOUND' | translate}}</p>
          <ngx-slick-carousel class="carousel custom-slider" #slickModal="slick-carousel" [config]="slideConfigs">
            <!-- <div ngxSlickItem *ngFor="let item of seriesinfo.episodes[seasonId];let i=index;" -->
              <!-- [routerLink]="['/series/watch/'+item.id+'/'+item.container_extension]" -->
            <div ngxSlickItem *ngFor="let item of seriesinfo.selectedEpisodes;let i=index;"
              class="slide cursor-pointer"  style="position: relative;" (mousedown)="onMouseDown($event)"
     (mouseup)="onMouseUpSeries($event, item)"
     (touchstart)="onMouseDown($event)"
     (touchend)="onMouseUpSeries($event, item)">
              <div class="pr-2">
                <div class="pr-2">
                  <div class="vlc-player" style="position: absolute;z-index: 999;left: 1rem;top: 0.5rem;">
                      <!-- <img   (click)="openVlcs($event, item)" src="./assets/images/new_icons/player.png" height="35px" width="35px" alt="" class="mr-2"> -->
                  </div>
                  <img class="search-imgseries" [src]="item.info.movie_image" alt="First slide" loading=lazy>
                  <p class="fs-14 search-title " title="{{ item.title }}">{{item.title }}</p>
                </div>
              </div>
            </div>
          </ngx-slick-carousel>
        </div>
      </div>
    </div>
    <div class="col-md-12 mt-3 pl-5" *ngIf="loadSeries">
      <!-- <h1 (click)="loadSeasons()">Mahadev ji ,jai shree ram</h1> -->
      <div class="d-flex justify-content-center align-item-center cursor-pointer" (click)="loadSeasons()" *ngIf="!isLoading ">
        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16">
         <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"/>
         <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"/>
       </svg>
     </div>
     <!-- <div *ngIf="isLoading" class="spinner-border spinner-border-lg fs-34" style="vertical-align:middle;" role="status"> -->
    </div>
  </div>
